<template>
  <div ref="bigScreen" class="big-screen-wrapper">
    <!-- <div class="header-box">
      <span class="header-title">天宙可视化平台</span>

      <div class="header-tip">
        <span title="关闭">
          <i class="el-icon-close" @click="toggleFullScreen"></i
        ></span>
      </div>
    </div> -->

    <div class="content">
      <!-- 地图背景 -->
      <div class="map-wrapper">
        <MapCenter ref="mapCenter" :beginTime="beginTime" :endTime="endTime" />
        <!-- <div class="status-legend">
          <div class="legend-item">
            <img src="@/assets/imgs/icon-check.png" class="legend-icon" />
            <span>检测</span>
          </div>
          <div class="legend-item">
            <img src="@/assets/imgs/icon-inspect.png" class="legend-icon" />
            <span>检查</span>
          </div>
          <div class="legend-item">
            <img src="@/assets/imgs/car.png" class="legend-icon" />
            <span>车辆</span>
          </div>
          <div class="legend-item">
            <img src="@/assets/imgs/iedevice.png" class="legend-icon" />
            <span>终端</span>
          </div>
          <div class="legend-item">
            <img src="@/assets/imgs/drone.png" class="legend-icon" />
            <span>无人机</span>
          </div>
        </div> -->
      </div>

      <!-- 左侧浮动面板 -->
      <div class="panel left-panel">
        <LeftPanel
          ref="leftPanel"
          :key="childKey"
          :isFullscreen="isFullscreen"
          :beginTime="beginTime"
          :endTime="endTime"
        />
      </div>
      <!-- 中间浮动面板 -->
      <!-- <div class="center-panel">
        <CenterPanel ref="centerPanel" />
      </div> -->
      <!-- 右侧浮动面板 -->
      <div class="panel right-panel">
        <RightAlertPanel
          ref="rightPanel"
          :key="childKey"
          :isFullscreen="isFullscreen"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LeftPanel from './components/LeftPanel/LeftPanel.vue'
import MapCenter from './components/MapCenter/MapCenter.vue'
import RightAlertPanel from './components/RightAlertPanel/RightAlertPanel.vue'

export default {
  name: 'BigScreen',
  components: {
    LeftPanel,
    MapCenter,
    RightAlertPanel
  },
  data() {
    return {
      isFullscreen: false,
      beginTime: '', //开始时间
      endTime: '', //结束时间
      resizeObserver: null,
      childKey: 1,
      quickMenus: [
        {
          title: '智能终端',
          link: '/manage/iemanage/smart-device',
          icon: 'el-icon-set-up',
          bgcolor: 'rgb(251, 158, 61)'
        },
        {
          title: '塔司管理',
          link: '/manage/iemanage/drivers-page',
          icon: 'el-icon-user',
          bgcolor: 'rgb(78, 142, 254)'
        },
        {
          title: '汇总报表',
          link: '/manage/iemanage/score-statistics',
          icon: 'el-icon-document',
          bgcolor: 'rgb(77, 206, 245)'
        },

        {
          title: '岗前播报',
          link: '/manage/iemanage/broadcast',
          icon: 'el-icon-tickets',
          bgcolor: 'rgb(84, 219, 145)'
        }
      ]
    }
  },
  async mounted() {
    // await this.defaultTime()
    // this.initResizeObserver()
    // this.toggleFullScreen()
  },
  beforeDestroy() {
    // if (this.resizeObserver) {
    //   this.resizeObserver.disconnect()
    // }
  },
  methods: {
    initResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        this.handleResize()
      })
      this.resizeObserver.observe(this.$refs.bigScreen)
      this.handleResize() // 首次也执行一次
    },
    handleResize() {
      console.log('..............')
      this.$refs.leftPanel?.resize?.()
      this.$refs.mapCenter?.resize?.()
      this.$refs.rightPanel?.resize?.()
    },
    // 默认时间
    defaultTime() {
      // 默认当前日期之前30天
      let sdate = new Date()
      let interval = -30 //间隔天数
      let caret = '-' //日期分隔符
      let strYear = sdate.getFullYear()
      let strDay = sdate.getDate()
      let strMonth = sdate.getMonth() + 1
      let patt1 = /^\d{4}-([0-1]?[0-9])-([0-3]?[0-9])$/ //判断输入的日期是否符合格式正则表达式
      if (!(sdate && typeof sdate == 'string' && patt1.test(sdate))) {
        sdate = new Date() //不满足日期的则使用当前年月日
      }
      interval = isNaN(parseInt(interval)) ? 0 : parseInt(interval) //若没有输入间隔，则使用当前日
      caret = caret && typeof caret == 'string' ? caret : ''
      let gdate = new Date(sdate).getTime() //获取指定年月日
      gdate = gdate + 1000 * 60 * 60 * 24 * interval //加减相差毫秒数
      let speDate = new Date(gdate) //获取指定好毫秒数时间
      let preYear = speDate.getFullYear()
      let preMonth = speDate.getMonth() + 1
      let preDay = speDate.getDate()
      preMonth = preMonth < 10 ? '0' + preMonth : preMonth
      strMonth = strMonth < 10 ? '0' + strMonth : strMonth
      preDay = preDay < 10 ? '0' + preDay : preDay
      strDay = strDay < 10 ? '0' + strDay : strDay
      let preDate = preYear + caret + preMonth + caret + preDay
      let endDate = strYear + '-' + strMonth + '-' + strDay
      this.beginTime = preDate
      this.endTime = endDate
      console.log(this.beginTime, this.endTime)
    },
    toggleFullScreen() {
      const element = this.$refs.bigScreen
      if (!this.isFullscreen) {
        element.requestFullscreen?.() || element.webkitRequestFullScreen?.()
        this.isFullscreen = true
        this.childKey += 1
      } else {
        document.exitFullscreen?.() || document.webkitCancelFullScreen?.()
        this.isFullscreen = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.big-screen-wrapper {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
}

.header-box {
  width: 100%;
  height: 60px;
  background-color: #5590d9;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 20px;
  font-weight: bold;
}
.header-title {
  color: white;
}
.header-toOther {
  font-weight: normal;
  margin-left: 20px;
  font-size: 14px;
}

.header-tip {
  display: flex;
  align-items: center;
  span {
    cursor: pointer;
  }
}
.content {
  position: relative;
  flex: 1;
  overflow: hidden;
}

/* 地图背景层 */
.map-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
}

/* 悬浮面板公共样式 */
.panel {
  position: absolute;
  top: 1vh;
  bottom: 1vh;
  width: 20vw;
  min-width: 300px;
  max-width: 480px;
  padding: 1vh 1vw;
  background: rgba(255, 255, 255, 0.25); /* 半透明背景 */
  border-radius: 10px;
  z-index: 8;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  // overflow-y: hidden;
  backdrop-filter: blur(2px); /* 毛玻璃效果，增强层次感 */
}
.center-panel {
  position: absolute;

  width: 42vw;
  /* width: 200px; */
  // height: 200px;
  top: 1vh;
  // bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  // min-width: 300px;
  // max-width: 480px;
  padding: 1vh 1vw;
  background: rgba(255, 255, 255, 0.25); /* 半透明背景 */
  border-radius: 10px;
  z-index: 6;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  // overflow-y: hidden;
  backdrop-filter: blur(2px); /* 毛玻璃效果，增强层次感 */
}
/* 左右浮动位置 */
.left-panel {
  left: 1vw;
}
.right-panel {
  right: 1vw;
}
.status-legend {
  position: absolute;
  bottom: 10vh;
  right: 25vw;
  z-index: 999;
  background: rgba(255, 255, 255, 0.8); /* 半透明背景 */
  padding: 10px 12px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  font-size: 14px;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.legend-item:last-child {
  margin-bottom: 0;
}

.legend-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
</style>
